import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { participants as participantsLayout } from 'constants/layout'
import {
  apiCodeLists,
  apiParticipants,
  apiAwards
} from 'helpers/decorators/api'
import { renderRoutes } from 'react-router-config'
import { routerAdapter } from 'helpers/decorators'

@routerAdapter()
@apiCodeLists([
  'genders',
  'phoneTypes',
  'titles',
  'employmentStatuses',
  'nationalities',
  'consentDeliveryTypes',
  'userRegistrationAssessmentStates',
  'projectLocationTypes',
  'participantPaymentStates',
  'personStates',
  'awardLevelTypes',
  'participantReasonsOfDeletionTypes'
])
@apiAwards({
  closeModalAfterUpdate: true
})
@apiParticipants({
  detail: true,
  redirectToParticipants: true,
  params: 'ORGANIZATION_COUNTRY'
})
class Participant extends Component {
  static propTypes = {
    children: PropTypes.any,
    tabs: PropTypes.object.isRequired,
    participants: PropTypes.object.isRequired,
    updateParticipant: PropTypes.func.isRequired,
    resendParentalConsentLink: PropTypes.func.isRequired,
    deleteParticipant: PropTypes.func.isRequired,
    deleteParticipantRegistration: PropTypes.func.isRequired,
    sendEmailInvitation: PropTypes.func.isRequired,
    sendRecoveryPassword: PropTypes.func.isRequired,
    sendConfirmationEmail: PropTypes.func.isRequired,
    onParticipantStateChange: PropTypes.func.isRequired,
    inviteParticipantToNextLevel: PropTypes.func.isRequired,
    fetchAllowedOfflineAwardLevels: PropTypes.func.isRequired,
    codeLists: PropTypes.object,
    route: PropTypes.object
  }

  render() {
    const {
      tabs,
      children,
      codeLists,
      participants,
      updateParticipant,
      deleteParticipant,
      deleteParticipantRegistration,
      sendRecoveryPassword,
      sendConfirmationEmail,
      sendEmailInvitation,
      onParticipantStateChange,
      fetchAllowedOfflineAwardLevels,
      inviteParticipantToNextLevel,
      resendParentalConsentLink,
      route
    } = this.props
    const participantAwards = get(participants, 'detail.awards') || []
    let links = []

    if (participantAwards.length > 0) {
      links = participantsLayout.tabsDetail
        .filter(item => {
          if (!item.onlyFor) {
            return item
          }
          return participantAwards.some(
            award => item.onlyFor === get(award, 'awardLevel.value')
          )
        })
        .map(item => ({
          ...item,
          visibility: undefined
        }))
    } else {
      links = participantsLayout.tabsDetail
    }

    const extraProps = {
      participants,
      codeLists,
      updateParticipant,
      deleteParticipant,
      deleteParticipantRegistration,
      sendEmailInvitation,
      sendRecoveryPassword,
      sendConfirmationEmail,
      onParticipantStateChange,
      fetchAllowedOfflineAwardLevels,
      resendParentalConsentLink,
      inviteParticipantToNextLevel
    }

    return (
      <div>
        {React.cloneElement(tabs, {
          links
        })}
        {children && React.cloneElement(children, extraProps)}
        {renderRoutes(route.routes, extraProps)}
      </div>
    )
  }
}

export default Participant
